//注入按钮
import * as dsfComponents from "./components";
import {DsfPolicyInterpretationList, DsfPolicyInterpretationDetail} from "./view/interpretation"

const components = {
  ...dsfComponents,
  DsfPolicyInterpretationList,
  DsfPolicyInterpretationDetail
};
const install = dsf.createDsfVueInstall("policy", components);
export default install;

export { install };
